// 引入对应的接口
import {
  getInquiryDetail,
  getOrderDetail,
  getFutuDetail,
  getFutuUnit
} from '@/api/automaticOrder'
// import moment from 'moment'

let state = {
  // 行权价格
  exercisePrice: '',
  // 是否清空
  isClear: true,
  // 控制dialog是否显示
  // isExecution: false,
  // isFinish: false,
  // isFail: false,
  // lists组件，table列表数据
  // 控制list部分的显示
  isListPageShow: true,
  queryLists: [],
  // 头部可交易所
  selectExchange: '',
  // 头部可交易品种
  selectedFutu: '',
  // 头部交易所和品类映射
  futuList: [],
  // 头部品类映射
  productIdList: {},
  // 可交易时间区间
  tradingdateList: [],
  // 当前价格接口独立
  // actualPrice: '',
  // 询价数据 保留当时字段待查
  inquiryInfo: {
    exercise_price: '',
    proposed_price: '',
    hands: '',
    actual_price: '',
    nominal_amount: '',
    option_type: 'Vanilla',
    nature_days: '',
    trade_days: '',
    last_trading_day: '',
    max_num: '',
    min_num: '',
    transaction_unit_unit: '',
    unit: '',
    limit_price: '',
    buy_or_sell: '',
    end_date: '',
    exercise_type: '',
    call_or_put: '',
    futu_code: '',
    transaction_purpose: '',
    price_maxdown: '',
    price_maxup: '',
    premium: ''
  },
  // 用于显示下单进行中和下单完成的数据
  orderInfo: {
    // 品种名称
    instrument_name: '',
    // 品种
    futu_code: '',
    // 买入或者卖出
    buy_or_sell: '',
    // 到期日
    end_date: '',
    // 交易价格
    deal_price: '',
    // 行权价格
    exercise_price: '',
    // 权利金
    premium: '',
    // 交易数量
    deal_num: '',
    // 名义金额
    nominal_amount: '',
    // 买涨买跌
    call_or_put: '',
    // 手数
    hands: '',
    // 暂时保留
    row_id: '',
    // 询价单序号
    order_id: '',
    // 权利金单价单位
    transaction_unit_unit: '',
    // hands单位
    unit: ''
  },
  isHeaderShow: true,
  isInquiryShow: true,
  isLoading: false
}

let mutations = {
  // 设置行权价格
  setExercisePrice (state, exercisePrice) {
    state.exercisePrice = exercisePrice
  },
  // 设置isListPageShow
  setIsClear (state, boolean) {
    state.isClear = boolean
  },
  // 设置productIdList
  setProductIdList (state, productObj) {
    state.productIdList = productObj
  },
  // 设置futulist
  setFutuList (state, futuListArray) {
    state.futuList = futuListArray
  },
  // 设置isListPageShow
  setIsListPageShow (state, boolean) {
    state.isListPageShow = boolean
  },
  // 设置querylists
  setQueryLists (state, queryLists) {
    state.queryLists = queryLists
  },

  setSelectExchange (state, selectExchange) {
    state.selectExchange = selectExchange
  },
  setSelectedFutu (state, selectedFutu) {
    state.selectedFutu = selectedFutu
  },
  // 设置可交易时间
  setTradingDateList (state, tradingdateList) {
    let tradingdateList_format = []

    for (let item of tradingdateList) {
      tradingdateList_format.push(item.trading_date)
    }

    state.tradingdateList = tradingdateList_format
  },
  // 清空inqueryInfo
  clearinquiryInfo (state) {
    state.inquiryInfo = {
      exercise_price: '',
      proposed_price: '',
      hands: '',
      actual_price: '',
      nominal_amount: '',
      option_type: 'Vanilla',
      nature_days: '',
      trade_days: '',
      last_trading_day: '',
      max_num: '',
      min_num: '',
      transaction_unit_unit: '',
      unit: '',
      limit_price: '',
      buy_or_sell: '',
      end_date: '',
      exercise_type: '',
      call_or_put: '',
      futu_code: '',
      transaction_purpose: '',
      price_maxdown: '',
      price_maxup: '',
      premium: ''
    }
  },

  // 清空orderInfo
  clearOrderInfo (state) {
    state.orderInfo = {
      // 品种名称
      instrument_name: '',
      // 品种
      futu_code: '',
      // 买入或者卖出
      buy_or_sell: '',
      // 到期日
      end_date: '',
      // 交易价格
      deal_price: '',
      // 行权价格
      exercise_price: '',
      // 权利金
      premium: '',
      // 交易数量
      deal_num: '',
      // 名义金额
      nominal_amount: '',
      // 买涨买跌
      call_or_put: '',
      // 手数
      hands: '',
      // 暂时保留
      row_id: '',
      // 询价单序号
      order_id: '',
      // 权利金单价单位
      transaction_unit_unit: '',
      // hands单位
      unit: ''
    }
  },
  // 将获取的数据合并入InquiryInfo
  setInquiryInfo (state, inquiryInfo) {
    Object.assign(state.inquiryInfo, inquiryInfo)
    // if (state.inquiryInfo.end_date != '') {
    // 	state.inquiryInfo.end_date = moment(
    // 		state.inquiryInfo.end_date,
    // 		'YYYYMMDD'
    // 	).format('YYYY-MM-DD')
    // }
  },
  // 设置订单详情的数据
  setOrderInfo (state, orderInfo) {
    Object.assign(state.orderInfo, orderInfo)
  },
  // 设置当前价格的数据
  // setActualPrice(state, actual_price) {
  //     state.actualPrice = actual_price
  // },
  setIsHeaderShow (state, boolean) {
    state.isHeaderShow = boolean
  },
  setIsLoading (state, boolean) {
    state.isLoading = boolean
  }
}

let actions = {
  // 请求获取 询价(inquiry)清单 的数据详情
  async queryInquiryDetail (context, inquiry_serial) {
    const res = await getInquiryDetail({
      inquiry_serial
    })
    let inquiryInfo = res.data
    context.commit('setExercisePrice', inquiryInfo.exercise_price)

    inquiryInfo.exercise_type = inquiryInfo.original_exercise_type
    inquiryInfo.exercise_price = inquiryInfo.original_exercise_pirce

    context.commit('setInquiryInfo', inquiryInfo)

    return inquiryInfo.data
  },

  // 请求获取 已完成订单（order） 的数据详情
  async queryFinishOrder (context, params) {
    await context.commit('clearOrderInfo')

    const order_id = params.order_id
    const futu_code = params.futu_code

    let resOrderDetail = await getOrderDetail({
      order_id
    })

    let resFutuDetail = await getFutuUnit({
      futu_code
    })

    const orderInfo = Object.assign(resOrderDetail.data, resFutuDetail.data)

    orderInfo.exercise_type = orderInfo.original_exercise_type
    orderInfo.exercise_price = orderInfo.original_exercise_pirce
    context.commit('setOrderInfo', orderInfo)
  },
  // 请求获取 进行中订单（order） 的数据详情
  async queryExecutionOrder (context, params) {
    await context.commit('clearOrderInfo')

    const order_id = params.order_id
    const futu_code = params.futu_code

    let resOrderDetail = await getOrderDetail({
      order_id
    })

    let resFutuDetail = await getFutuUnit({
      futu_code
    })

    const orderInfo = Object.assign(resOrderDetail.data, resFutuDetail.data)

    orderInfo.exercise_type = orderInfo.original_exercise_type
    orderInfo.exercise_price = orderInfo.original_exercise_pirce
    context.commit('setOrderInfo', orderInfo)
  },

  // 请求获取 进行中订单（order） 的数据详情
  async queryFailOrder (context, params) {
    await context.commit('clearOrderInfo')

    const order_id = params.order_id
    const futu_code = params.futu_code

    let resOrderDetail = await getOrderDetail({
      order_id
    })

    let resFutuDetail = await getFutuDetail({
      futu_code
    })

    const orderInfo = Object.assign(resOrderDetail.data, resFutuDetail.data)

    orderInfo.exercise_type = orderInfo.original_exercise_type
    orderInfo.exercise_price = orderInfo.original_exercise_pirce
    context.commit('setOrderInfo', orderInfo)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
